export default "__VITE_ASSET__DfyU1kNp__"